{
  "$id": "pentest-report",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_version",
    "generated_by",
    "framework_version",
    "report_id",
    "workflow",
    "generated_at",
    "report_path",
    "sidecar_path",
    "source_report_path",
    "source_report_id",
    "stack",
    "runtime",
    "coverage",
    "findings",
    "blocked_checks",
    "sources_used",
    "methodology",
    "next_remediation_priorities",
    "raw_evidence_paths"
  ],
  "properties": {
    "schema_version": { "const": "1" },
    "generated_by": { "const": "paqad-ai" },
    "framework_version": { "type": "string", "minLength": 1 },
    "report_id": { "type": "string", "minLength": 1 },
    "workflow": { "type": "string", "enum": ["pentest", "pentest-retest"] },
    "generated_at": { "type": "string", "format": "date-time" },
    "report_path": { "type": "string", "minLength": 1 },
    "sidecar_path": { "type": "string", "minLength": 1 },
    "source_report_path": { "type": ["string", "null"] },
    "source_report_id": { "type": ["string", "null"] },
    "stack": {
      "type": "object",
      "additionalProperties": false,
      "required": ["primary", "traits", "toolchains"],
      "properties": {
        "primary": { "type": "string", "minLength": 1 },
        "traits": { "type": "array", "items": { "type": "string" } },
        "toolchains": { "type": "array", "items": { "type": "string" } }
      }
    },
    "runtime": {
      "type": "object",
      "additionalProperties": false,
      "required": ["target_url", "status", "detail"],
      "properties": {
        "target_url": { "type": ["string", "null"] },
        "status": {
          "type": "string",
          "enum": ["reachable", "unreachable", "not-configured", "blocked"]
        },
        "detail": { "type": "string", "minLength": 1 }
      }
    },
    "coverage": {
      "type": "object",
      "additionalProperties": false,
      "required": ["docs", "tests", "code", "runtime", "database", "blocked_checks"],
      "properties": {
        "docs": { "type": "boolean" },
        "tests": { "type": "boolean" },
        "code": { "type": "boolean" },
        "runtime": { "type": "boolean" },
        "database": { "type": "boolean" },
        "blocked_checks": { "type": "array", "items": { "type": "string" } }
      }
    },
    "findings": {
      "type": "array",
      "items": {
        "type": "object",
        "additionalProperties": true,
        "required": [
          "id",
          "title",
          "description",
          "impact",
          "effort",
          "possible_solution_direction",
          "how_to_reproduce",
          "impact_area",
          "evidence",
          "category",
          "status",
          "confidence",
          "source_types",
          "affected_modules",
          "affected_packages",
          "runtime_required",
          "manual_follow_up"
        ],
        "properties": {
          "id": { "type": "string", "minLength": 1 },
          "title": { "type": "string", "minLength": 1 },
          "description": { "type": "string", "minLength": 1 },
          "impact": { "type": "string", "enum": ["high", "medium", "low"] },
          "effort": { "type": "string", "enum": ["low", "medium", "high"] },
          "possible_solution_direction": { "type": "string", "minLength": 1 },
          "how_to_reproduce": { "type": "array", "items": { "type": "string" } },
          "impact_area": { "type": "array", "items": { "type": "string" } },
          "evidence": { "type": "array", "items": { "type": "string" } },
          "category": { "type": "string", "minLength": 1 },
          "status": {
            "type": "string",
            "enum": ["open", "coverage-gap", "fixed", "still-open", "needs-manual-verification"]
          },
          "confidence": { "type": "number", "minimum": 0, "maximum": 1 },
          "source_types": {
            "type": "array",
            "items": { "type": "string", "enum": ["docs", "tests", "code", "runtime", "advisory"] }
          },
          "affected_modules": { "type": "array", "items": { "type": "string" } },
          "affected_packages": { "type": "array", "items": { "type": "string" } },
          "runtime_required": { "type": "boolean" },
          "manual_follow_up": { "type": "boolean" },
          "retest_status": {
            "type": "string",
            "enum": ["fixed", "still-open", "needs-manual-verification"]
          }
        }
      }
    },
    "blocked_checks": { "type": "array", "items": { "type": "string" } },
    "sources_used": { "type": "array", "items": { "type": "string" } },
    "methodology": { "type": "array", "items": { "type": "string" } },
    "next_remediation_priorities": { "type": "array", "items": { "type": "string" } },
    "raw_evidence_paths": { "type": "array", "items": { "type": "string" } }
  }
}
